import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "ShopTheLookLazy" */ './ShopTheLook'), {
    fallback: null,
});
